import { CheckCircleIcon, HStack, Icon, Text } from '@chaine/keychaine';
import React from 'react';
import { Direction } from 'react-animated-conversation';
import { Logo } from '../_shared/logo';
import { AnimatedConversation } from './chat/index';
export function Chat() {
    return React.createElement(AnimatedConversation, { messages: MESSAGES });
}
const MESSAGES = [
    {
        body: 'Hey, can you confirm your case count?',
        sentViaCopilot: true,
        delay: 0,
        direction: Direction.Outbound
    },
    {
        avatarName: 'Jack',
        body: 'Yeah I just got loaded with 24 cases.',
        direction: Direction.Inbound,
        delay: 2000,
        senderDetails: (React.createElement(HStack, { spacing: 2 },
            React.createElement(Text, { color: "text.primary", fontSize: "sm", fontWeight: "semibold" }, "Jack"),
            React.createElement(Text, { color: "text.secondary", fontSize: "sm", fontWeight: "regular" }, "Driver at Best Trucking")))
    },
    {
        body: 'Updating case count in TMS to 24',
        delay: 2000,
        messageIcon: React.createElement(Logo, null),
        systemMessage: true
    },
    {
        body: 'Thanks!',
        direction: Direction.Outbound,
        delay: 3000
    },
    {
        body: 'Will confirm ETA to dropoff at 1:00 PM',
        delay: 2000,
        messageIcon: React.createElement(Icon, { as: CheckCircleIcon, mr: 2 }),
        systemMessage: true
    },
    {
        body: 'What is your ETA to the dropoff?',
        delay: 2000,
        direction: Direction.Outbound,
        sentViaCopilot: true
    },
    {
        avatarName: 'Aubrey',
        body: '@Jack should be there around 2:00 PM.',
        delay: 2000,
        direction: Direction.Inbound,
        highlightedText: '@Jack',
        senderDetails: (React.createElement(HStack, { spacing: 2 },
            React.createElement(Text, { color: "text.primary", fontSize: "sm", fontWeight: "semibold" }, "Aubrey"),
            React.createElement(Text, { color: "text.secondary", fontSize: "sm", fontWeight: "regular" }, "Dispatcher at Best Trucking")))
    },
    {
        body: 'Updating ETA in TMS to 2:00 PM',
        delay: 2000,
        messageIcon: React.createElement(Logo, null),
        systemMessage: true
    }
];
